module.exports = __webpack_public_path__ + "img/46de8d5.webp";